import { render, staticRenderFns } from "./CreditBureauList.vue?vue&type=template&id=74955cfe&"
import script from "./CreditBureauList.vue?vue&type=script&lang=js&"
export * from "./CreditBureauList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports